// @flow
type TRateBlock = {
    name?: string,
};

type TRateBlockState = {
    data: TRateBlock,
};
const initialState: TRateBlockState = {
    data: {
        isConfirmed: false,
    },
};

type TSetRateBlock = {payload: TRateBlock, type: 'SET_RATE_BLOCK'};

type TRateBlockActionList = TSetRateBlock;

function rateBlockReducer(state: TRateBlockState = initialState, {type, payload}: TRateBlockActionList) {
    switch (type) {
        case 'SET_RATE_BLOCK':
            return {
                ...state,
                data: payload,
            };
        case 'SET_CONFIRM':
            return {
                ...state,
                data: payload,
            };
        default:
            return state;
    }
}

export {rateBlockReducer};
export type {TRateBlock, TSetRateBlock, TRateBlockState};
